import Vue from 'vue'
import { handleize } from 'lib/util'

Vue.component('size-selector', {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isSimple: {
      type: Boolean,
      default: false
    },
    active: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    getVariant: {
      type: Function
    }
  },
  filters: {
    handleize
  },
  template: `
    <div class="size-selector">
      <div class="size-selector__list-wrapper">
        <div class="size-selector__list f aic jcc" :class="{ 'size-selector__list--multiple': options.length > 2 }">
          <button
            class="size-selector__list-item aic jcc relative"
            :class="{'is-loading': (loading && active === option) || (loading && isSimple), single: isSimple || options.length == 1 }"
            @click="$emit('add-to-cart', option)"
            v-for="(option, i) in options"
            :disabled="getVariant(option) ? !getVariant(option).available : true"
          >
            <span v-if="!isSimple" class="p2">{{ option }}</span>
            <span v-else class="p2">Buy Now</span>
            <i class="spinner spinner--abs spinner--sm" :class="{'is-active': (loading && active === option) || (loading && isSimple)}"></i>
          </button>
        </div>
      </div>
    </div>
  `
})
